// extracted by mini-css-extract-plugin
export var actionButton = "_bh-1";
export var actionButtons = "_bh-2";
export var actions = "_bh-0";
export var aiUnread = "_bh-10";
export var alignCenter = "_bh-h";
export var backWrapper = "_bh-3";
export var cellContainer = "_bh-4";
export var checkboxContainer = "_bh-5";
export var contentContainer = "_bh-6";
export var contentHeader = "_bh-8";
export var conversationsTableWrapper = "_bh-s";
export var draftReplyBadgeContainer = "_bh-m";
export var dropdownItem = "_bh-b";
export var dropdownItemsContainer = "_bh-a";
export var dropdownTitle = "_bh-c";
export var errorIcon = "_bh-7";
export var filter = "_bh-d";
export var gray = "_bh-i";
export var headerActionButtons = "_bh-e";
export var headerCheckboxContainer = "_bh-f";
export var icon = "_bh-j";
export var menuContainer = "_bh-k";
export var noMoreTicketsIcon = "_bh-12";
export var noMoreTicketsSubText = "_bh-13";
export var oneLine = "_bh-l";
export var optionsButton = "_bh-n";
export var plus = "_bh-o";
export var portalButtonsWrapper = "_bh-g";
export var red = "_bh-p";
export var scrolledTop = "_bh-9";
export var search = "_bh-q";
export var selectedConversationsCount = "_bh-r";
export var spinner = "_bh-t";
export var strong = "_bh-u";
export var summaryCell = "_bh-v";
export var tableContainer = "_bh-11";
export var tagContainer = "_bh-w";
export var threeDots = "_bh-x";
export var twoLines = "_bh-y";
export var unread = "_bh-z";